export * from './activityHistory.model';
export * from './address.model';
export * from './batch.model';
export * from './bin.model';
export * from './customer.model';
export * from './die.model';
export * from './eod.model';
export * from './horizon.model';
export * from './horizonStat.model';
export * from './job.model';
export * from './jobDie.model';
export * from './loginForm.model';
export * from './material.model';
export * from './oaDetails.model';
export * from './oaTemplate.model';
export * from './order.model';
export * from './product.model';
export * from './productSubAssembly.model';
export * from './registerForm.model';
export * from './reprintPage.model';
export * from './scrap.model';
export * from './setting.model';
export * from './shipment.model';
export * from './shipmentAddress.model';
export * from './shippingGroup.model';
export * from './jobSpecs.model';
export * from './task.model';
export * from './template.model';
export * from './templateEditForm.model';
export * from './user.model';
export * from './yellowbag.model';
export * from './jobLocation.model';
export * from './role.model';
export * from './pto.model';
export * from './shipmentCharge.model';
export * from './rfid-artwork.model';
export * from './customerAttributes.model';
export * from './customerSuppliedAccount.model';


// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/models/index.ts